import AsyncLottie from '@zillow/async-component';
import type { ReactElement } from 'react';
import { Box, Button, Heading, Page, Paragraph } from '@zillow/constellation-10';
import animationData from './cat-animation-data.json';

/* istanbul ignore next */
const lottieLoader = () => import(/* webpackChunkName: "lottie" */ 'react-lottie');

export function ErrorPage({
  errorCode,
  errorDetails,
  errorMessage,
  homePageText,
  homePageUrl,
}: ErrorPageProps): ReactElement {
  return (
    <Page.Root css={{ background: 'white' }}>
      <Page.Header>
        <Heading level={1}>Something broke</Heading>
      </Page.Header>
      <Page.Content>
        <Heading level={2} textStyle="responsive.heading-md">
          {errorCode && <>Error code: {errorCode} - </>}
          {errorMessage}
        </Heading>
        {errorDetails ? <Paragraph textStyle="body-sm">{errorDetails}</Paragraph> : null}
        <Button emphasis="filled" tone="brand" css={{ marginTop: 'lg' }} asChild>
          <a href={homePageUrl}>{homePageText}</a>
        </Button>
        <Box css={{ height: '400px' }}>
          <AsyncLottie loader={lottieLoader} options={{ animationData, loop: false }} />
        </Box>
      </Page.Content>
    </Page.Root>
  );
}

interface ErrorPageProps {
  errorCode?: number;
  errorMessage?: string;
  errorDetails?: React.ReactNode;
  homePageText?: string;
  homePageUrl?: string;
}
